import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Box
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { TempoMedioStatus } from '../../services/relatorioService';

interface TempoMedioPorStatusProps {
  dados: TempoMedioStatus[];
}

const TempoMedioPorStatus: React.FC<TempoMedioPorStatusProps> = ({ dados }) => {
  const obterCorTempo = (tempo: number): 'success' | 'warning' | 'error' => {
    if (tempo <= 3) return 'success';
    if (tempo <= 7) return 'warning';
    return 'error';
  };

  const formatarTempo = (dias: string | number): string => {
    const diasNum = typeof dias === 'string' ? parseFloat(dias) : dias;
    if (diasNum === 0) return 'N/A';
    if (diasNum < 1) return `${Math.round(diasNum * 24)}h`;
    if (diasNum === 1) return '1 dia';
    return `${Math.round(diasNum)} dias`;
  };

  if (!dados || dados.length === 0) {
    return (
      <Card>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <AccessTimeIcon sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="h6">Idade Média das Tarefas por Status Atual</Typography>
          </Box>
          <Typography color="textSecondary">Nenhum dado disponível</Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <AccessTimeIcon sx={{ mr: 1, color: 'primary.main' }} />
          <Typography variant="h6">Idade Média das Tarefas por Status Atual</Typography>
        </Box>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Tempo total desde a criação até agora/conclusão, agrupado pelo status atual da tarefa
        </Typography>
        
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><strong>Status Atual</strong></TableCell>
                <TableCell align="center"><strong>Tarefas</strong></TableCell>
                <TableCell align="center"><strong>Idade Média</strong></TableCell>
                <TableCell align="center"><strong>Mais Rápida</strong></TableCell>
                <TableCell align="center"><strong>Mais Antiga</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dados.map((item, index) => (
                <TableRow key={index} hover>
                  <TableCell>{item.status}</TableCell>
                  <TableCell align="center">
                    <Chip 
                      label={item.totalTarefas} 
                      size="small" 
                      color="primary" 
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Chip 
                      label={formatarTempo(item.tempoMedio)}
                      size="small"
                      color={obterCorTempo(parseFloat(item.tempoMedio.toString()))}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2" color="textSecondary">
                      {formatarTempo(item.maisRapida)}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2" color="textSecondary">
                      {formatarTempo(item.maisLenta)}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default TempoMedioPorStatus;
